// Auto-generated normalizer for table: CAR_BOOKING.ExtrasAcumuladoSemana
export function extrasAcumuladoSemanaNormalize(row) {
  return {
    id: row.id ?? row.Id ?? row['id'] ?? 0,
    idReserva: row.idReserva ?? row.IdReserva ?? row['idReserva'] ?? 0,
    idChofer: row.idChofer ?? row.IdChofer ?? row['idChofer'] ?? 0,
    semana: row.semana ?? row.Semana ?? row['semana'] ?? 0,
    anio: row.anio ?? row.Anio ?? row['anio'] ?? 0,
    horasExtras: row.horasExtras ?? row.HorasExtras ?? row['horasExtras'] ?? 0,
    horasAcumuladas: row.horasAcumuladas ?? row.HorasAcumuladas ?? row['horasAcumuladas'] ?? 0,
    fechaCorte: row.fechaCorte ?? row.FechaCorte ?? row['fechaCorte'] ?? null,
    activo: row.activo ?? row.Activo ?? row['activo'] ?? false,
  };
}